import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=023f201c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f201c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023f201c')) {
      api.createRecord('023f201c', component.options)
    } else {
      api.reload('023f201c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=023f201c&scoped=true&", function () {
      api.rerender('023f201c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mZlPIkmmTQur/JS/comp/Accordion.vue"
export default component.exports